import React from 'react';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
const ToastContext = /*#__PURE__*/ createContext({
  showToast: () => {},
});
function typeClasses(type) {
  if (type === 'success') return 'bg-emerald-600 text-white';
  if (type === 'error') return 'bg-rose-600 text-white';
  return 'bg-slate-800 text-white';
}
export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([]);
  const dismiss = useCallback((id) => {
    setToasts((prev) => prev.filter((t) => t.id !== id));
  }, []);
  const showToast = useCallback(
    (message, type = 'info') => {
      const id = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
      setToasts((prev) => [
        ...prev,
        {
          id,
          message,
          type,
        },
      ]);
      setTimeout(() => dismiss(id), 3000);
    },
    [dismiss]
  );
  const value = useMemo(
    () => ({
      showToast,
    }),
    [showToast]
  );
  return (
    <ToastContext.Provider value={value}>
      {children}
      <div className="fixed top-4 right-4 z-[100000] flex flex-col gap-2 pointer-events-none">
        {toasts.map((t) => (
          <div
            key={t.id}
            className={`max-w-sm px-4 py-3 rounded-xl shadow-lg text-sm font-bold pointer-events-auto ${typeClasses(t.type)}`}
          >
            {t.message}
          </div>
        ))}
      </div>
    </ToastContext.Provider>
  );
}
export function useToast() {
  return useContext(ToastContext);
}
